export default __webpack_public_path__ + "static/media/open-24-hours.4be43895.png";